/* PawLi before/after — auto slide loop until user interacts, then manual (drag/touch). Pure JS. */
class PawliBa extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.pawli-ba__viewport');
    if (!this.viewport) return;
    this.pos = 50;
    this.auto = this.dataset.auto !== 'false';
    this.dragging = false;
    this._setPos(50);

    this.viewport.addEventListener('pointerdown', (e) => this._start(e));
    window.addEventListener('pointermove', (e) => this._move(e));
    window.addEventListener('pointerup', () => this._end());

    if (this.auto) {
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver((ents) => {
          ents.forEach((en) => { if (en.isIntersecting && this.auto) this._loop(); else this._stopLoop(); });
        }, { threshold: 0.2 });
        this._io.observe(this);
      } else {
        this._loop();
      }
    }
  }
  disconnectedCallback() { this._stopLoop(); if (this._io) this._io.disconnect(); }

  _setPos(p) {
    this.pos = Math.max(0, Math.min(100, p));
    this.style.setProperty('--pos', this.pos);
  }
  _loop() {
    if (this._raf || !this.auto) return;
    const start = performance.now();
    const dur = 5200;
    const tick = (now) => {
      if (!this.auto) return;
      const t = ((now - start) % dur) / dur;         // 0..1
      const eased = 0.5 - 0.5 * Math.cos(t * 2 * Math.PI); // smooth 0..1..0
      this._setPos(15 + eased * 70);                  // between 15% and 85%
      this._raf = requestAnimationFrame(tick);
    };
    this._raf = requestAnimationFrame(tick);
  }
  _stopLoop() { if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; } }
  _fromEvent(e) {
    const rect = this.viewport.getBoundingClientRect();
    return ((e.clientX - rect.left) / rect.width) * 100;
  }
  _start(e) {
    this.auto = false;            // hand off to manual permanently
    this._stopLoop();
    this.dragging = true;
    this.classList.add('is-manual');
    this._setPos(this._fromEvent(e));
    e.preventDefault();
  }
  _move(e) { if (this.dragging) this._setPos(this._fromEvent(e)); }
  _end() { this.dragging = false; }
}
if (!customElements.get('pawli-ba')) customElements.define('pawli-ba', PawliBa);
